import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ap_link = _resolveComponent("ap-link")

  return (_openBlock(), _createElementBlock("div", null, [
    ($props.company == 'Portal')
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          innerHTML: _ctx.$t($options.portalNoShiptoTranslateId, 'Please link your account to at least one Ship-To in order to use the MyAirProducts application.')
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("p", {
          key: 1,
          innerHTML: _ctx.$t('ml_107433', { company: $props.company }, 'Please link your account to at least one Ship-To in order to use the MyAirProducts application.')
        }, null, 8, _hoisted_2)),
    _createElementVNode("p", null, [
      _createVNode(_component_ap_link, {
        href: `https://account.airproducts.com/shiptos?ReturnUrl=${$data.location}`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('ml_104220')), 1)
        ]),
        _: 1
      }, 8, ["href"])
    ])
  ]))
}